import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_ATTENDANCE_MONTH_YEAR:
      return { ..._.mapKeys(action.payload, "value") };
    case type.FETCH_ATTENDANCES:
      return { ..._.mapKeys(action.payload, "EmployeeId") };
    case type.FETCH_ATTENDANCE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_ATTENDANCE:
      return { ...state, ..._.mapKeys(action.payload, "EmployeeId") };
    // return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_ATTENDANCE:
      return { ...state, ..._.mapKeys(action.payload, "EmployeeId") };
    // return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_ATTENDANCE:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
